//
import { ExtendFile } from 'src/components/file-thumbnail/types';
import { withImageSize } from 'src/utils/optimizedImageUrl';
import Image from '../../image';
//

// ----------------------------------------------------------------------

type Props = {
  file: ExtendFile | string | null;
};

export default function SingleFilePreview({ file }: Props) {
  if (!file) {
    return null;
  }

  const raw = typeof file === 'string' ? file : file.preview;
  const imgUrl = withImageSize(raw || '', 'md');

  return (
    <Image
      alt="file preview"
      src={imgUrl}
      sx={{
        top: 8,
        left: 8,
        zIndex: 8,
        borderRadius: 1,
        position: 'absolute',
        width: 'calc(100% - 16px)',
        height: 'calc(100% - 16px)',
      }}
    />
  );
}
